import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';

import { CategoryDetails } from './details/category-details.model';

import { CatalogService } from '../catalogs/catalog.service';
import {AmberApi} from 'app/core/models/api-helpers';

@Injectable()
export class CategoryService {

    private catalogRoute: string = '/agora/product-data/catalogs/{{keyRoute}}/details';

    constructor(
        private configService: ConfigService,
        private requestService: RequestService,
        private catalogService: CatalogService
    ) { }

    edit(details: any): Observable<CategoryDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.categories.edit.api;
        return this.requestService.post(url, details);
    }

    add(details: any): Observable<CategoryDetails> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.categories.add.api;
        return this.requestService.post(url, details);
    }

    delete(details: any): Observable<CategoryDetails> {
            let url = this.configService.get('server').url + this.configService.get('endpoints').agora.categories.delete.api;
            return this.requestService.post(url, details);
    }
    getCategoryDetails(id: string): Observable<CategoryDetails> {
            let url = this.configService.get('server').url + this.configService.get('endpoints').agora.categories.details.api + '/' + id;
            return this.requestService.get(url);
    }
    getTopicslist(): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').agora.topics.list.api;
        return this.requestService.get(url);
    }



    getFields() {
        let fields = [
            {
                key: 'id',
                label: 'ID',
                type: 'hidden',
                required: false
            }, {
                key: 'name',
                label: 'Name',
                type: 'textbox',
                required: true
            }, {
                key: 'code',
                label: 'Code',
                type: 'textbox',
                required: true
            }, {
                key: 'keywords',
                label: 'Keywords',
                type: 'autocomplete',
                required: false,
                source: this.catalogService.keywordsSource
            }, {
                key: 'description',
                label: 'Description',
                type: 'textbox',
                required: false
            }, {
                key: 'imageUrl',
                label: 'Image Url',
                type: 'textbox',
                required: false
            }, {
                key: 'trending',
                label: 'Trending',
                type: 'radio',
                options: [
                    {key: true,  value: 'Yes'},
                    {key: false,  value: 'No'}
                ],
                required: false,
                default: false
            }, {
                key: 'categoryFamily',
                label: 'Category Family',
                type: 'multi-dropdown',
                required: false,
                dictionaryUrl: this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.productCategoryFamily.api
            }, {
                key: 'ipStatement',
                label: 'IP Statement',
                type: 'html-editor',
                modules: {
                    toolbar: [
                        { 'header': [1, 2, 3, 4, 5, 6, false] },
                        { 'list': 'ordered' }, { 'list': 'bullet' }
                    ]
                }
            }, {
                key: 'catalog.id',
                label: 'Catalog',
                type: 'dropdown',
                required: true,
                dictionaryUrl:
                this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.catalog.api
            }, {
                key: 'topics',
                label: 'Leapest Topics',
                type: 'multi-dropdown',
                required: false,
                config: {
                    dictType: 'extractDict',
                    keyFieldName: 'id',
                    valueFieldName: 'title'
                },
                dictionaryUrl: this.configService.get('server').url + this.configService.get('endpoints').agora.topics.listTopics.api+'?$title=1'
            }, {
                key: 'customTopics',
                label: 'Custom Topics',
                type: 'multi-dropdown',
                required: false,
                config: {
                    dictType: 'extractDict',
                    keyFieldName: 'key',
                    valueFieldName: 'value'
                    // filter: 'topic'
                },
                dictionaryUrl: this.configService.get('server').url + this.configService.get('endpoints').agora.customTopics.dictionaryIdTitle.api
            }
        ];
        return fields;
    };
    getDetailsFields() {
        let fields = [
            {
                key: 'name',
                label: 'Name',
                type: 'text'
            }, {
                key: 'code',
                label: 'Code',
                type: 'text'
            }, {
                key: 'keywords',
                label: 'Keywords',
                type: 'list'
            }, {
                key: 'description',
                label: 'Description',
                type: 'text'
            }, {
                key: 'imageUrl',
                label: 'Image Url',
                type: 'text'
            }, {
                key: 'trending',
                label: 'Trending',
                type: 'map',
                map: {
                    true: 'Yes',
                    false: 'No'
                }
            }, {
                key: (e: any) => {
                    let result = [];
                    if(e.categoryFamily && e.categoryFamily.length) e.categoryFamily.forEach(element => {
                        result.push(element.configValue);
                    });
                    return result;
                },
                label: 'Category Family',
                type: 'list'
            }, {
                id: 'ipStatement',
                key: 'ipStatement',
                label: 'IP Statement',
                type: 'html'
            }, {
                key: 'catalog.name',
                label: 'Catalog',
                type: 'link',
                config: {
                    route: this.catalogRoute,
                    keyRoute: 'catalog.id'
                }
            }, {
                key: (e: any) => {
                    let result = [];
                    if(e.topics && e.topics.length) e.topics.forEach(element => {
                        result.push(element.title);
                    });
                    return result;
                },
                label: 'Leapest Topics',
                type: 'list'

            }, {
                key: (e: any) => {
                    let result = [];
                    if(e.customTopics && e.customTopics.length) e.customTopics.forEach(element => {
                        result.push(element.title);
                    });
                    return result;
                },
                label: 'Custom Topics',
                type: 'list'

            }, {
                key: 'online',
                label: 'Online',
                type: 'map',
                map: {
                    true: 'Yes',
                    false: 'No'
                }
            }
        ];
        return fields;
    };

    formatData(details: any) {
        const obj = {
            categoryFamily: details.categoryFamily ? details.categoryFamily.map(_ => {return { id: _ }}) : []
        };

        const topics = details.topics ? details.topics.map(el => {
            if(el.hasOwnProperty('id')) {
                return el
            } else {
                return { 'id': el}
            }} ) : [];
        details['topics'] = topics;

        const customTopics = details.customTopics ? details.customTopics.map(el => {
            if(el.hasOwnProperty('id')) {
                return el
            } else {
                return { 'id': el}
            }} ) : [];
        details['customTopics'] = customTopics;

        let result = Object.assign({}, details);
        result = Object.assign(result, obj);
        return result;
    }

    topicsInCatalogs(code: string) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.topic.byCatalog.api;
        return this.requestService.get(url, {'$title': 1, 'catalogCode': code}).extract(AmberApi.Data);
    }

    catalogDictionary() {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.catalog.byCode.api;
        return this.requestService.get(url, {'$title': 1}).extract(AmberApi.Data);
    }

    customTopicDictionary(catalogCode: string) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').agora.customTopics.dictionaryIdTitle.api;
        return this.requestService.get(url, {'$title': 1, 'catalogCode': catalogCode}).extract(AmberApi.Data);
    }
}



// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/categories/category.service.ts